module.exports = __webpack_public_path__ + "static/media/logo-vida.4480de05.svg";